import { render } from "./HinweiseZurAuszahlung.pug?vue&type=template&id=41baeb86&lang=pug"
import script from "./HinweiseZurAuszahlung.js?vue&type=script&lang=js"
export * from "./HinweiseZurAuszahlung.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__